/**
 * @generated SignedSource<<86e2b2d48bd9b0d1afbe4749b212e851>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateProfileInput = {
  clientMutationId?: string | null | undefined;
  patch: ProfilePatch;
  rowId: any;
};
export type ProfilePatch = {
  beliefSystemId?: any | null | undefined;
  biography?: string | null | undefined;
  birthdate?: any | null | undefined;
  childrenPreferenceId?: any | null | undefined;
  closestCity?: string | null | undefined;
  createdAt?: any | null | undefined;
  educationLevelId?: any | null | undefined;
  genderId?: any | null | undefined;
  genderOther?: string | null | undefined;
  geolocation?: PointInput | null | undefined;
  heightCm?: number | null | undefined;
  heightFt?: number | null | undefined;
  heightIn?: number | null | undefined;
  instagram?: string | null | undefined;
  name?: string | null | undefined;
  occupation?: string | null | undefined;
  politicalViewId?: any | null | undefined;
  pronounId?: any | null | undefined;
  rowId?: any | null | undefined;
  school?: string | null | undefined;
  updatedAt?: any | null | undefined;
  userId?: any | null | undefined;
  vaccinationStatusId?: any | null | undefined;
};
export type PointInput = {
  x: number;
  y: number;
};
export type useProfileMutation$variables = {
  input: UpdateProfileInput;
};
export type useProfileMutation$data = {
  readonly updateProfile: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useProfile_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useProfileMutation = {
  response: useProfileMutation$data;
  variables: useProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProfilePayload",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useProfile_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProfilePayload",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "beliefSystemId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "biography",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "childrenPreferenceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "closestCity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "educationLevelId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "genderId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "genderOther",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heightCm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heightFt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heightIn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instagram",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "occupation",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "politicalViewId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pronounId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rowId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "school",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vaccinationStatusId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "activities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v3/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "age",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BeliefSystem",
                        "kind": "LinkedField",
                        "name": "beliefSystem",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChildrenPreference",
                        "kind": "LinkedField",
                        "name": "childrenPreference",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeetConnection",
                        "kind": "LinkedField",
                        "name": "deets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Deet",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v3/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EducationLevel",
                        "kind": "LinkedField",
                        "name": "educationLevel",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Gender",
                        "kind": "LinkedField",
                        "name": "gender",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PoliticalView",
                        "kind": "LinkedField",
                        "name": "politicalView",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pronoun",
                        "kind": "LinkedField",
                        "name": "pronoun",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaccinationStatus",
                        "kind": "LinkedField",
                        "name": "vaccinationStatus",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c54ca4ab23a4c3cab933002648498738",
    "id": null,
    "metadata": {},
    "name": "useProfileMutation",
    "operationKind": "mutation",
    "text": "mutation useProfileMutation(\n  $input: UpdateProfileInput!\n) {\n  updateProfile(input: $input) {\n    query {\n      ...useProfile_query\n      id\n    }\n  }\n}\n\nfragment OwnProfileInfo_profile on Profile {\n  activities {\n    nodes {\n      name\n      id\n    }\n  }\n  age\n  beliefSystem {\n    name\n    id\n  }\n  biography\n  childrenPreference {\n    name\n    id\n  }\n  closestCity\n  deets {\n    nodes {\n      name\n      id\n    }\n  }\n  educationLevel {\n    name\n    id\n  }\n  gender {\n    name\n    id\n  }\n  genderOther\n  heightCm\n  heightFt\n  heightIn\n  occupation\n  politicalView {\n    name\n    id\n  }\n  pronoun {\n    name\n    id\n  }\n  school\n  userId\n  vaccinationStatus {\n    name\n    id\n  }\n}\n\nfragment useProfile_query on Query {\n  currentUser {\n    profile {\n      beliefSystemId\n      biography\n      childrenPreferenceId\n      closestCity\n      educationLevelId\n      genderId\n      genderOther\n      heightCm\n      heightFt\n      heightIn\n      instagram\n      occupation\n      politicalViewId\n      pronounId\n      rowId\n      school\n      vaccinationStatusId\n      ...OwnProfileInfo_profile\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bdc4a0e078d20ee5516d5a810132c05";

export default node;
